export const TOAST_TYPES = {
  INFO: "is-info",
  SUCCESS: "is-success",
  WARNING: "is-warning",
  ERROR: "is-danger",
};

export const configToast = (context, containerSelector = "body") => {
  const config = {
    context: context,
    containerSelector: containerSelector,
  };
  return {
    open: (message, type = TOAST_TYPES.SUCCESS) => {
      config.context.$buefy.toast.open({
        container: config.containerSelector,
        message,
        type,
        duration: 5000,
      });
    },
  };
};


export const toastService = {
  context: null,
  setContext(context) {
    this.context = context
  },
  openToast(message, type = TOAST_TYPES.SUCCESS) {
    if (this.context) {
      const toast = configToast(this.context)
      toast.open(message, type)
    } else {
      console.warn('Contexto no configurado para el toast.')
    }
  }
}
